export const Login = {
  Title: 'Prihlásenie',
  Username: 'Meno používateľa',
  Password: 'Heslo',
  Submit: 'Prihlásiť',
};
